import React, { useState } from "react";
import { Photo } from "../../types";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const originalPath = src => {
	return src.replace("_DIMENSION_/", "");
};

export default function ClubGallery({ photos }: { photos: Photo[] }) {
	let photosToShow = [];
	let morePhotos = null;

	const [photoIndex, setPhotoIndex] = useState(0);
	const [isOpen, setOpen] = useState(false);

	photosToShow = photos ? photos : null;
	if (photosToShow && photosToShow.length > 4) {
		photosToShow = photosToShow.slice(0, 4);
		morePhotos = photos.length - 4;
	}

	const openLightBox = photoIndex => {
		setPhotoIndex(photoIndex);
		setOpen(true);
	};

	const closeLightBox = () => {
		setOpen(false);
	};

	if (!photosToShow || photosToShow.length == 0) {
		return null;
	}

	return (
		<>
			<div className="photos">
				{photosToShow.map((photo, index) => (
					<div
						className="photo"
						key={photo.photoId}
						style={{
							backgroundImage: `url(${photo.path
								.replace("stage-", "")
								.replace("_DIMENSION_", "thumb6")})`,
						}}
						onClick={() => openLightBox(index)}
					>
						{index == 3 && morePhotos ? <div className="overlay">+{morePhotos}</div> : ""}
					</div>
				))}
			</div>

			{isOpen ? (
				<Lightbox
					mainSrc={originalPath(photos[photoIndex].path).replace("stage-", "")}
					nextSrc={originalPath(photos[(photoIndex + 1) % photos.length].path).replace("stage-", "")}
					prevSrc={originalPath(photos[(photoIndex + photos.length - 1) % photos.length].path).replace(
						"stage-",
						""
					)}
					onCloseRequest={closeLightBox}
					onMovePrevRequest={() => setPhotoIndex((photoIndex + photos.length - 1) % photos.length)}
					onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % photos.length)}
					enableZoom={false}
				/>
			) : null}
		</>
	);
}
